const he = {
  translation: {
    Login: "התחברות",
    // Amount: "התחברות",
    // Date: "התחברות",
  },
};
export default he;
